import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SelectComponent } from 'components/select/select.component';

import { LayoutService } from 'common/dynamic-form/services/layout.service';

import { autoPickSelectOptions } from './select.utils';

import { ISPFieldType } from '../../model';
import { ISPFieldTypeBase } from '../field-type-base.class';

/**
 * Select field component
 *
 * Use only with Formly
 */
@UntilDestroy()
@Component({
  selector: 'isp-formly-select-field',
  templateUrl: './select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectFieldComponent
  extends ISPFieldTypeBase<ISPFieldType.Select>
  implements OnInit
{
  @ViewChild('select', { static: true })
  selectRef: ElementRef<SelectComponent>;

  @ViewChild('select', { read: ElementRef, static: true })
  selectElementRef: ElementRef<HTMLElement>;

  constructor(private readonly layoutService: LayoutService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.props.options$.pipe(untilDestroyed(this)).subscribe(options => {
      const isSelectDepends = Boolean(this.field.props.originalControl.$depend);
      autoPickSelectOptions(options, this.model, this.field, isSelectDepends);
    });

    if (this.props.layoutPlace === 'content') {
      const selectElement = this.selectElementRef.nativeElement;
      this.layoutService
        .needCloseDropdown$(selectElement)
        .pipe(untilDestroyed(this))
        .subscribe(() => {
          this.selectRef.nativeElement.closeDropdown();
        });
    }
  }

  /**
   * Model change event handler
   *
   * @param value - select's new value
   */
  onModelChange(value: any): void {
    if (value === undefined && this.field.defaultValue !== undefined) {
      this.formControl.setValue(this.field.defaultValue, {
        emitEvent: false,
      });
    }
  }
}
